import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../../common/html/element'
import { DefaultVsicName } from '../../../../DefaultVsicName'
import { Content } from './Content'
import { ShowDataIndustry } from './ShowDataIndustry'
import { Tab } from './Tab'

export const ChartGrowthRate = () => {
  return (
    <div className="w50 h100 flexColumn">
      <div className="dFlex justifyContentBetween mb1">
        <div className="flexColumn">
          <Translate
            value="industryOverview.macroeconomics.GDP_GDP_GROWTH_RATE"
            className="fw600"
          />
          <DefaultVsicName />
        </div>
        <div>
          <Tab />
        </div>
      </div>

      <ShowDataIndustry />

      <Element style={{ color: '#9c9c9c', marginTop: 14 }}>
        <Translate value="industryOverview.macroeconomics.GDP_GROWTH_RATE" />
      </Element>

      <div className="flex1" id="macroGDPChartGrowthRateId">
        <Content />
      </div>
    </div>
  )
}
